/**
 * @file baiduInput ua校验
 * @author chenjiufu <chenjiufu@baidu.com>
 */
/**
 * 判断当前浏览器是否为baiduInput
 *
 * @return {boolean} 判断当前浏览器是否为baiduInput
 */
export default function is() {
    // 输入对应App的UA标识
    // return /tieba\//i.test(navigator.userAgent);
    return /baiduinput/i.test(navigator.userAgent);
}
//# sourceMappingURL=is.js.map